// @flow

import { IS_CURRENCY_BY_SURFACE, SAVE_SELECTED_STORE } from './storeReducer';
import { store } from '../../network/reduce';
import type { ReconciliationStore } from '../../types/shoppingCenterType';

export const storeIsCurrencyBySurface = (bool: boolean): Function =>
  (dispatch: () => void) => dispatch(store(IS_CURRENCY_BY_SURFACE, bool));

export const updateRetailerSelected = (retailerStore: ?ReconciliationStore): Function =>
  (dispatch: () => void) => dispatch(store(SAVE_SELECTED_STORE, retailerStore));
